<template>
  <div class="news-info-box">
    <div v-if="!inList" class="news-title">
      <p>{{ detail.newsTitle }}</p>
    </div>
    <div v-if="!inList" class="news-sub-title">
      时间：<span>{{ detail.newsCreateTime }}</span>&nbsp;<span>{{ detail.newsComefrom }}</span>
    </div>
    <div class="news-content">
      <p v-html="detail.newsContent"></p>
    </div>
  </div>
</template>

<script>
import { newsDetail } from "@/api/apis";
export default {
  props: {
    inList: {
      type: Boolean,
      default: false
    },
    queryId: {
      type: [String, Number],
      default: ","
    }
  },
  data() {
    return {
      detail: {}
    }
  },
  watch: {
    queryId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.queryDetail();
        } else {
          this.detail = {};
        }
      },
    }
  },
  methods: {
    queryDetail() {
      newsDetail(this.queryId).then(res => {
        if (res.code === 200) {
          this.detail = res.data;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.news-info-box {
  .news-title {
    display: block;
    border-bottom: 1px solid #ddd;
    line-height: 1.6;
    font-size: 24px;
    color: #333;
    padding: 20px 0;
    text-align: center;
  }
  .news-sub-title {
    text-align: center;
    height: 50px;
    line-height: 50px;
    font-size: 12px;
    text-align: center;
    color: #777777;
  }
}
</style>